import AnalyticsNav from "@assets:analytics_nav.svg";
import Bot from "@assets:bot.svg";
import BotNav from "@assets:bot_nav.svg";
import BotSearch from "@assets:bot_search.svg";
import ChatMessage from "@assets:chat_message.svg";
import CheckIcon from "@assets:check.svg";
import CopyIcon from "@assets:copy-alt.svg";
import DislikeIcon from "@assets:dislike.svg";
import DocTranslate from "@assets:doc_translate.svg";
import DocsNav from "@assets:docs_nav.svg";
import DocumentIcon from "@assets:document.svg";
import LikeIcon from "@assets:like.svg";
import Lock from "@assets:lock.svg";
import NemoLogo from "@assets:logo.svg";
import InnovumLogo from "@assets:logo_innovum.svg";
import Search from "@assets:search.svg";
import SendMessage from "@assets:send_message.svg";
import UploadIcon from "@assets:upload.svg";
import URLIcon from "@assets:url.svg";
import WriteIcon from "@assets:write.svg";
import { SvgIcon, SxProps } from "@mui/material";
import { ElementType } from "react";
import { BiDislike, BiLike, BiMessageDetail } from "react-icons/bi";
import { FaStar } from "react-icons/fa";
import {
  FaCopy,
  FaDownload,
  FaFileLines,
  FaFolderOpen,
  FaLanguage,
  FaMicrophone,
  FaRegCircleCheck,
  FaRobot,
} from "react-icons/fa6";
import { IoMdChatbubbles, IoMdCheckmarkCircle } from "react-icons/io";
import {
  LuAudioLines,
  LuFileText,
  LuHeadphones,
  LuMessageSquare,
} from "react-icons/lu";
import {
  MdAccessTime,
  MdAnalytics,
  MdBarChart,
  MdCancel,
  MdGTranslate,
  MdInsights,
  MdOutlineCancel,
  MdPieChart,
  MdRecordVoiceOver,
  MdSmartToy,
  MdSpeakerNotes,
  MdTranslate,
  MdTrendingUp,
} from "react-icons/md";
import { RiChatVoiceLine, RiRobot2Line } from "react-icons/ri";

const Icons = {
  nemoIcon: NemoLogo,
  lockIcon: Lock,
  botIcon: Bot,
  innovumIcon: InnovumLogo,
  chatMessageIcon: ChatMessage,
  dislikeIcon: BiDislike,
  likeIcon: BiLike,
  starIcon: FaStar,
  searchIcon: Search,
  botNav: BotNav,
  docsNav: DocsNav,
  analyticsNav: AnalyticsNav,
  botSearch: BotSearch,
  sendMessage: SendMessage,
  checkIcon: CheckIcon,
  copyIcon: CopyIcon,
  uploadIcon: UploadIcon,
  documentIcon: DocumentIcon,
  urlIcon: URLIcon,
  writeIcon: WriteIcon,
  dislike2XIcon: DislikeIcon,
  like2XIcon: LikeIcon,
  docTranslate: DocTranslate,
  audio: LuAudioLines,
  time: MdAccessTime,
  checkMarkCircle: IoMdCheckmarkCircle,
  cancel: MdCancel,
  circleCheck: FaRegCircleCheck,
  outlineCancel: MdOutlineCancel,
  download: FaDownload,
  copiedIcon: FaCopy,
  // Chat icons
  smartToy: MdSmartToy,
  robot: FaRobot,
  robotLine: RiRobot2Line,
  chatBubbles: IoMdChatbubbles,
  messageSquare: LuMessageSquare,
  messageDetail: BiMessageDetail,
  speakerNotes: MdSpeakerNotes,
  // Docs icons
  fileLines: FaFileLines,
  fileText: LuFileText,
  folderOpen: FaFolderOpen,
  // Audio icons
  microphone: FaMicrophone,
  headphones: LuHeadphones,
  voiceOver: MdRecordVoiceOver,
  chatVoice: RiChatVoiceLine,
  // Translation icons
  translate: MdTranslate,
  gTranslate: MdGTranslate,
  language: FaLanguage,
  // Analytics icons
  analytics: MdAnalytics,
  pieChart: MdPieChart,
  barChart: MdBarChart,
  trendingUp: MdTrendingUp,
  insights: MdInsights,
};

interface SVGInternalIconProps {
  sx?: SxProps;
  icon: keyof typeof Icons;
}

export const SVGInternalIcon = ({ sx, icon }: SVGInternalIconProps) => {
  const Icon = Icons[icon] as ElementType;
  return (
    <SvgIcon
      inheritViewBox
      sx={{
        ...sx,
      }}
      component={Icon}
    />
  );
};
